import PlatformError from "../PlatformError";

export default new PlatformError(
  "WARN",
  "You have tried to start a study already in progress, please use the original link to start from the beginning.",
  "RouteError",
  "User followed an incorrect link",
  "app.error.route"
);
